import request from 'src/api'
import { addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'

export default () => {
  $('#offcanvasRight').on('click', '.add_service_description', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    $(this).closest('.tab-pane').find('.service_description_rows').prepend($(this).data('fields').replace(regexp, time))

    let selected_frequency = $(this).closest('.row').find('.select-frequency option:selected').val()
    $('.tab-pane.active .service_description_row:first select[name*="frequency"]').val(selected_frequency)
    $('.tab-pane.active .service_description_row:first input[name*="area"]:first').attr('list', 'datalist_area_' + time)
    $('.tab-pane.active .service_description_row:first #datalist_area_').attr('id', 'datalist_area_' + time)
    $('.tab-pane.active .service_description_row:first input[name*="task"]:first').attr('list', 'datalist_task_' + time)
    $('.tab-pane.active .service_description_row:first #datalist_task_').attr('id', 'datalist_task_' + time)

    $('.tab-pane.active .service_description_row:first .service_description_weekday').select2({
      dropdownParent: $('#offcanvasRight'),
      minimumInputLength: 0,
      placeholder: I18n.t("selects.select_weekdays"),
      width: '100%'
    })

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click', '#add_tasks', function(event) {
    let selected_area = $(this).closest('.row').find('.select-area option:selected').text()

    if (selected_area !== $(this).closest('.row').find('.select-area option:first').text()) {
      lockButton('#add_tasks')

      const clientId = $('#service-descriptions-link button').data('client_id')
      const country = $('#service-descriptions-link button').data('country')

      request.get('/clients/' + clientId + '/service_description_options')
        .set('X-Requested-With', 'XMLHttpRequest')
        .accept('json')
        .query({
          area: selected_area,
          country: country
        })
        .then(res => {
          let tasks = res.body
          let missing_tasks = tasks
          let selected_frequency = $(this).closest('.row').find('.select-frequency option:selected').val()
          let current_tasks = []
          let current_rows = $('.tab-pane.active .service_description_row')

          for (var i = 0; i < current_rows.length; i++) {
            if ($(current_rows[i]).is(":visible")) {
              let area = $(current_rows[i]).find('input[name*="area"]:first').val()
              let task = $(current_rows[i]).find('input[name*="task"]:first').val()

              if (area && task) {
                if (area.trim().toLowerCase() === selected_area.trim().toLowerCase()) {
                  current_tasks.push(task.trim())
                }
              }
            }
          }

          if (current_tasks.length > 0) {
            missing_tasks = tasks.filter(x => !current_tasks.includes(x))
          }
          missing_tasks = missing_tasks.reverse()

          for (var i = 0; i < missing_tasks.length; i++) {
            $('.tab-pane.active .add_service_description').click()
            $('.tab-pane.active .service_description_row:first input[name*="area"]').val(selected_area)
            $('.tab-pane.active .service_description_row:first input[name*="task"]').val(missing_tasks[i])
            $('.tab-pane.active .service_description_row:first select[name*="frequency"]').val(selected_frequency)
          }

          $('.tab-pane.active .service_description_row:first .service_description_weekday').select2({
            dropdownParent: $('#offcanvasRight'),
            minimumInputLength: 0,
            placeholder: I18n.t("selects.select_weekdays"),
            width: '100%'
          })

          unlockButton('#add_tasks')
        })
        .catch(err => {
          handleErrors(err, '#add_tasks')
        })
    } else {
      addToast(I18n.t("selects.select_area"), 'alert')
    }
  })

  $('#offcanvasRight').on('focus', '.service_description_task', function(event) {
    let selected_area = $(this).closest('.row').find('input[name*="area"]').val()

    if (selected_area.length) {
      const clientId = $('#service-descriptions-link button').data('client_id')
      const country = $('#service-descriptions-link button').data('country')

      request.get('/clients/' + clientId + '/service_description_options')
        .set('X-Requested-With', 'XMLHttpRequest')
        .accept('json')
        .query({
          area: selected_area,
          country: country
        })
        .then(res => {
          let datalist = $(this).closest('.row').find('.datalist-tasks')
          $(datalist).empty()

          for (var i = 0; i < res.body.length; i++) {
            $(datalist).append('<option value="' + res.body[i] + '">' + res.body[i] + '</option>')
          }
        })
        .catch(err => {
          handleErrors(err, null)
        })
    }
  })

  $('#offcanvasRight').on('change', '#copy_customer', function(event) {
    const customerId = $(this).val()
    if (customerId) {
      lockButton('#copy_customer')

      request.get('/customers/' + customerId + '/service_descriptions/copy_customer')
        .set('X-Requested-With', 'XMLHttpRequest')
        .accept('json')
        .then(res => {
          let missing_tasks = res.body
          let current_rows = $('.tab-pane.active .service_description_row')
          for (var i1 = 0; i1 < missing_tasks.length; i1++) {
            let found = false
            for (var i2 = 0; i2 < current_rows.length; i2++) {
              if ($(current_rows[i2]).is(":visible")) {
                let area = $(current_rows[i2]).find('input[name*="area"]:first').val()
                let task = $(current_rows[i2]).find('input[name*="task"]:first').val()

                if (area && task) {
                  if (area.trim().toLowerCase() === missing_tasks[i1][0].trim().toLowerCase() && task.trim().toLowerCase() === missing_tasks[i1][1].trim().toLowerCase()) {
                    found = true
                    break
                  }
                }
              }
            }

            if (!found) {
              $('.tab-pane.active .add_service_description').click()
              $('.tab-pane.active .service_description_row:first input[name*="area"]').val(missing_tasks[i1][0])
              $('.tab-pane.active .service_description_row:first input[name*="task"]').val(missing_tasks[i1][1])
              $('.tab-pane.active .service_description_row:first select[name*="frequency"]').val(missing_tasks[i1][3]).trigger('change')
              $('.tab-pane.active .service_description_row:first select[name*="weekdays"]').val(missing_tasks[i1][4]).trigger('change')
            }
          }

          $("#copy_customer").val(null).trigger('change')

          unlockButton('#copy_customer')
        })
        .catch(err => {
          handleErrors(err, '#copy_customer')
        })
    }
  })
  $('#offcanvasRight').on('change', '#change_frequencies', function(event) {
    const freq = $(this).val()
    if (freq) {
      const frequencies = $('.tab-pane.active .service_description_row select[name*="frequency"]')
      for (var i = 0; i < frequencies.length; i++) {
        $(frequencies[i]).val(freq).trigger('change')
      }
    }
  })

  $('#offcanvasRight').on('click', '.remove_service_description_row', function(event) {
    dirty = true

    $(this).prev('input[type=hidden]').val('1')
    $(this).closest('.row').addClass('d-none')

    return event.preventDefault()
  })

  $('#mainModal').on('click', '#confirmImportServiceDescription', function() {
    lockButton('#confirmImportServiceDescription')

    let files = $('#importSDFile')[0].files
    if (files.length > 0) {
      request.post($('#mainForm').attr('action') + '/import_service_description')
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .attach('file', files[0])
        .then(res => {
          setTimeout(() => checkStatusSDImport(res.body.jobId), 1000)
        })
        // 🚨 **F-12: this was a hand-inlined copy of `handleErrors` and it CRASHED on the case that matters.**
        // It guarded `err.response !== undefined` when building the message and then dereferenced
        // `err.response.status` unguarded on the next line — so a network failure or a timeout, where
        // superagent gives no `response` at all, threw a TypeError **inside the catch handler**. The user
        // saw nothing: no toast, no unlocked button, the fullscreen loader left up. On a file upload, which
        // is precisely where timeouts happen.
        // ✅ `handleErrors` is the one place that gets this right — no response means
        // `errors.unexpected_error` (or `no_network` when the browser knows it is offline), and it unlocks
        // the button and hides the modal. Passing the selector also fixes the other half: the old `else`
        // branch hid the modal but never unlocked the button, against the rule in `docs/JAVASCRIPT.md`.
        .catch(err => handleErrors(err, '#confirmImportServiceDescription'))
    } else {
      addToast(I18n.t("errors.no_file"), 'alert')
      unlockButton('#confirmImportServiceDescription')
    }
  })
}

function checkStatusSDImport(jobId) {
  request.get(`/background_jobs/${jobId}`)
    .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
    .accept('json')
    .then(res => {
      if (res.body.done === 1) {
        addToast(I18n.t("import_service_description_modal.success"), 'notice')
        $.getScript($('#mainForm').attr('action') + '/edit')
      } else if (res.body.done === -1) {
        const error = I18n.t("import_service_description_modal.error") + '<br/>' + res.body.error_message
        addToast(error, 'error')
        mainModal.hide()
      } else {
        setTimeout(() => checkStatusSDImport(jobId), 1000); // Poll every 1 seconds
      }
    });
}

// Main: poll both jobs in parallel and continue after both have finished
window.checkServiceDescriptionPdfStatus = async function(jobId1, jobId2) {
  try {
    await Promise.all([
      waitForJob(jobId1, { intervalMs: 1000, timeoutMs: 60000 }),
      waitForJob(jobId2, { intervalMs: 1000, timeoutMs: 60000 })
    ]);
    $('#service-descriptions-link button').click()
  } catch (err) {
    handleErrors(err, null)
    fullscreenLoader.hide()
  }
}
